import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import { useRouter } from "vue-router/composables";
import { GalaxyApi } from "@/api";
import { useObjectStoreStore } from "@/stores/objectStoreStore";
import localize from "@/utils/localization";
import { rethrowSimple } from "@/utils/simple-error";
import { byteFormattingForChart, useDataLoading } from "./util";
import BarChart from "./Charts/BarChart.vue";
import ObjectStoreActions from "./ObjectStoreActions.vue";
import OverviewPage from "./OverviewPage.vue";
import ShowObjectStore from "./ShowObjectStore.vue";
import WarnDeletedHistories from "./WarnDeletedHistories.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoresStorageOverview',
    setup(__props) {
        const router = useRouter();
        const objectStoresBySizeData = ref(null);
        const { getObjectStoreNameById } = useObjectStoreStore();
        const { isLoading, loadDataOnMount } = useDataLoading();
        loadDataOnMount(async () => {
            const { data, error } = await GalaxyApi().GET("/api/users/{user_id}/objectstore_usage", {
                params: { path: { user_id: "current" } },
            });
            if (error) {
                rethrowSimple(error);
                return;
            }
            const objectStoresBySize = data.sort((a, b) => b.total_disk_usage - a.total_disk_usage);
            objectStoresBySizeData.value = objectStoresBySize.map((objectStore) => ({
                id: objectStore.object_store_id,
                label: getObjectStoreNameById(objectStore.object_store_id) ?? objectStore.object_store_id,
                value: objectStore.total_disk_usage,
            }));
        });
        function onViewObjectStore(objectStoreId) {
            router.push({ name: "ObjectStoreOverview", params: { objectStoreId } });
        }
        return { __sfc: true, router, objectStoresBySizeData, getObjectStoreNameById, isLoading, loadDataOnMount, onViewObjectStore, localize, byteFormattingForChart, BarChart, ObjectStoreActions, OverviewPage, ShowObjectStore, WarnDeletedHistories, LoadingSpan };
    }
});
